import React from 'react';
import { Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { connect3 } from 'assets/learning';

const ConnectLearningScreen4 = () => {
  const { t } = useTranslation();
  return (
    <>
      <h4 id="chapter-1-2" className='text-connect'>{t('learning.connect.13')}</h4>
      <div className='d-flex flex-direction-row'>
        <div className='col-8'>
          <p>{t('learning.connect.14')}</p>
        </div>
        <div className='col-4 text-center'>
          <Image src={connect3} width={'50%'} style={{ objectFit: 'contain' }} />
        </div>
      </div>
      <p>{t('learning.connect.15.1')}<a href="https://drive.google.com/file/d/1liEn52A-VBU4IdpPat8nHi0ym_BvArEO/view" target='_blank' rel='nooppener noreferrer' className='text-connect'>{t('learning.connect.15.2')}</a></p>
      <div className='text-center d-print-none'>
        <br />
        <iframe width={'50%'} height="315" src="https://www.youtube.com/embed/OTP9qT2s0wA?si=xqmzZUdun5XgWK_x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <br />
      </div>
    </>
  )
}

export default ConnectLearningScreen4;